import { useWindowTitle } from '@cibo/profile'
import { Typography } from '@mui/material'
import { PaginatedAgreementsTable, usePaginatedAgreementsTableColumns } from 'features/Agreements'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const SoilHealthReports = () => {
  const { t } = useTranslation('impact/pages/Admin/AgreementsOverview')
  useWindowTitle(t('title', { context: 'soil-health' }))
  const { download, userId, year } = usePaginatedAgreementsTableColumns()

  const columns = useMemo(() => [year, userId, download], [])

  return (
    <>
      <Typography variant="h5">{t('title', { context: 'soil-health' })}</Typography>
      <PaginatedAgreementsTable
        baseQuery={{
          agreementType: 'soilHealth',
          status: 'agreed',
        }}
        columns={columns}
        includeStats
      />
    </>
  )
}
